<div class="dialog editCollection">
    @if(data) {
        <div class="dialog-title">
        <h2>
            @if(data.uuid) {
               {{'dialog.edit.collection'|translate}}
            } @else {
                {{'dialog.create.collection'|translate}}
            }
        </h2>
            <button (click)="close()" mat-icon-button><mat-icon  fontIcon="close"></mat-icon></button>
        </div>
    }

<mat-dialog-content>
    <form [formGroup]="editForm" (submit)="confirm()">
        <div class="row">
            <div class="col-12">
                <mat-form-field>
                    <mat-label>{{'collection.name'| translate}}</mat-label>
                    <input matInput formControlName="name" aria-describedby="nameRequired nameeMinLength nameMaxLength">
                </mat-form-field>
                @if(editForm.controls['name'].invalid && (editForm.get('name')?.touched || editForm.controls['name'].dirty)) {

                    @if(editForm.controls['name'].hasError('required')) {
                        <div class="error" id="nameRequired" role="alert">{{'error.required' | translate}}</div>
                    }
                    @if(editForm.controls['name'].hasError('minlength')) {
                        <div class="error" id="nameMinLength" role="alert">{{'error.minLength' | translate}} 3</div>
                    }
                    @if(editForm.controls['name'].hasError('maxlength')) {
                        <div class="error" role="alert" id="nameMaxLength">{{'error.maxLength' | translate}} 255</div>
                    }
                }
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <mat-form-field>
                    <mat-label>{{'collection.description'| translate}}</mat-label>
                    <textarea matInput formControlName="description" cdkTextareaAutosize cdkAutosizeMinRows="8" cdkAutosizeMaxRows="12"></textarea>
                </mat-form-field>
            </div>
        </div>
    </form>
    <div class="row">
        <div class="col-12">
            <div class="btn-row">
                <button type="button" (click)="close()" mat-button>{{'button.cancel'|translate}}</button>
                <button type="submit" mat-raised-button (click)="confirm()" [disabled]="!editForm.valid">{{'button.save'|translate}}</button>
            </div>
        </div>
    </div>
</mat-dialog-content>
</div>



<!-- <div id="collection-new-form">
    <label for="collection-name">Name:
        <input type="text" id="collection-name" [(ngModel)]="data.name"
            required minlength="3" maxlength="255" #name="ngModel">
    </label>
    <label for="collection-description">Description:
        <textarea id="collection-description" [(ngModel)]="data.description"></textarea>
    </label>
    <button [disabled]="name.invalid" (click)="confirm()">{{ isNew() ? 'Create' : 'Edit' }}</button>
</div>-->
